import { AxiosPromise } from 'axios';
import api from './api';

export function getCurrentFamilies() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get('/families')
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
